import { render } from "./EC.vue?vue&type=template&id=22106425"
import script from "./EC.vue?vue&type=script&lang=js"
export * from "./EC.vue?vue&type=script&lang=js"

import "./EC.vue?vue&type=style&index=0&id=22106425&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__